import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Dibujo del recorrido GPS real (sin mapa externo): línea de inicio (verde) a fin (rojo). */
export const TrazoGPS = ({ pings }) => {
  const pts = (pings || []).filter((p) => p.lat && p.lng);
  if (pts.length < 2) return <div className="text-sm text-zinc-500 py-4 text-center" data-testid="trazo-vacio">Aún no hay suficientes puntos GPS para dibujar el recorrido.</div>;
  const lats = pts.map((p) => p.lat), lngs = pts.map((p) => p.lng);
  const [minLa, maxLa, minLo, maxLo] = [Math.min(...lats), Math.max(...lats), Math.min(...lngs), Math.max(...lngs)];
  const W = 600, H = 360, pad = 20;
  const sx = (W - 2 * pad) / Math.max(maxLo - minLo, 1e-6), sy = (H - 2 * pad) / Math.max(maxLa - minLa, 1e-6), s = Math.min(sx, sy);
  const xy = (p) => [pad + (p.lng - minLo) * s, H - pad - (p.lat - minLa) * s];
  const d = pts.map((p, i) => `${i ? "L" : "M"}${xy(p).map((v) => v.toFixed(1)).join(",")}`).join(" ");
  const [a, b] = [xy(pts[0]), xy(pts[pts.length - 1])];
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto bg-zinc-50 border border-zinc-200 rounded" data-testid="trazo-gps">
      <path d={d} fill="none" stroke="#002FA7" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={a[0]} cy={a[1]} r="7" fill="#16A34A" /><circle cx={b[0]} cy={b[1]} r="7" fill="#DC2626" />
    </svg>
  );
};

export const HistorialRutas = ({ pilotoId, fecha, onPick }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!pilotoId) return;
    api.get("/domicilios/rutas-historial", { params: { piloto_id: pilotoId } }).then(({ data }) => setRows(data || [])).catch(() => setRows([]));
  }, [pilotoId, fecha]);
  if (!rows.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="rutas-historial">
      {rows.map((r) => (
        <button key={r.fecha} onClick={() => onPick(r.fecha)} className={`text-xs font-bold px-2 py-1 rounded border ${r.fecha === fecha ? "bg-[#002FA7] text-white border-[#002FA7]" : "bg-white border-zinc-300"}`} data-testid={`ruta-hist-${r.fecha}`}>
          {r.fecha}{r.cierre_automatico ? " · 8 p.m." : r.finalizada_at ? "" : " · en curso"}
        </button>
      ))}
    </div>
  );
};
